import { SortableKeys, SummarySortConfig } from './summaryTypes';

type SummaryRow = Record<string, unknown>;

const getSortValue = (row: SummaryRow, key: SortableKeys): string | number => {
  switch (key) {
    case 'customer':
      return (row.customerName as string) ?? '';
    case 'site':
      return (row.siteName as string) ?? '';
    case 'plant':
      return (row.plantName as string) ?? '';
    case 'assetType':
      return (row.assetType as string) ?? '';
    case 'assetName':
      return (row.assetName as string) ?? '';
    case 'status':
      return (row.status as string) ?? '';
    case 'alertsCount':
      return parseInt(String(row.alertsCount), 10) || 0;
    case 'lastCommunication':
      return (row.lastCommunication as string) ?? '';
    case 'firstCommunication':
      return (row.firstCommunication as string) ?? '';
    case 'ioTDeviceConnectionState':
      return (row.ioTDeviceConnectionState as string) ?? '';
    default:
      return '';
  }
};

const compareValues = (
  aValue: string | number,
  bValue: string | number,
  key: SortableKeys,
  direction: 'asc' | 'desc'
): number => {
  const ascMultiplier = direction === 'asc' ? 1 : -1;

  if (aValue === undefined || aValue === null || aValue === '') {
    return ascMultiplier;
  }
  if (bValue === undefined || bValue === null || bValue === '') {
    return -ascMultiplier;
  }

  if (key === 'alertsCount') {
    if (aValue < bValue) return -ascMultiplier;
    if (aValue > bValue) return ascMultiplier;
    return 0;
  }

  const valA = String(aValue).toLowerCase();
  const valB = String(bValue).toLowerCase();
  if (valA < valB) return -ascMultiplier;
  if (valA > valB) return ascMultiplier;
  return 0;
};

export const sortSummaryRows = <T extends SummaryRow>(
  items: T[],
  sortConfig: SummarySortConfig | null
): T[] => {
  if (!sortConfig) {
    return items;
  }

  const sorted = [...items];
  sorted.sort((a, b) => {
    const aValue = getSortValue(a, sortConfig.key);
    const bValue = getSortValue(b, sortConfig.key);
    return compareValues(aValue, bValue, sortConfig.key, sortConfig.direction);
  });
  return sorted;
};
